import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './PendingFieldIndicator.css';
import { EmployeeObjectiveOverridesFragment } from '../../../../__generated__/graphql';
import { getTextWithoutHtmlTags } from '../../../../../../utils/html';

type Props = {
  fieldName: string;
  overrides: EmployeeObjectiveOverridesFragment | null | undefined;
};

const i18prefix = 'performanceReview.goals2.approvalStatus';

export const PendingFieldIndicator: React.FC<
  React.PropsWithChildren<Props>
> = ({ fieldName, overrides }) => {
  if (!overrides) {
    return null;
  }

  const pendingField = overrides.pendingFields.find(
    (f) => f.fieldName === fieldName,
  );

  if (!pendingField) {
    return null;
  }

  return <PendingDot oldDisplayValue={pendingField.oldDisplayValue} />;
};

const PendingDot: React.FC<
  React.PropsWithChildren<{ oldDisplayValue: string | null }>
> = ({ oldDisplayValue }) => {
  const { t } = useTranslation();
  const plainValue = oldDisplayValue
    ? getTextWithoutHtmlTags(oldDisplayValue)
    : null;
  const oldValueText = plainValue
    ? t(`${i18prefix}.oldValueWas`, { value: plainValue })
    : t(`${i18prefix}.oldValueWasNotSet`);

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          <span className="pt-1">
            {t(`${i18prefix}.fieldChangePendingApproval`)}. {oldValueText}
          </span>
        </Tooltip>
      }>
      <span className="pending-dot" />
    </OverlayTrigger>
  );
};
